import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";

const MapComponent = ({
  isLoaded,
  mapCenter,
  markerPosition,
  onMarkerDragEnd,
}) => {
  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <GoogleMap
      mapContainerStyle={{ height: "400px", width: "100%" }}
      center={mapCenter}
      zoom={12}
    >
      <Marker
        position={markerPosition}
        onDragEnd={onMarkerDragEnd}
        draggable
        title="Drag to locate your new dive site"
      />
    </GoogleMap>
  );
};

export default MapComponent;
